import {
    BADGE_ART_CSS_COLORS,
    BadgeArtSpec,
    BadgeArtState,
    badgeArtVersion,
    renderBadgeSvg,
} from '../../../common/badge-art/index.js'

const cache = new Map<string, { __html: string }>()

/**
 * `dangerouslySetInnerHTML` value for a badge, memoised per instance + art. React DOM 19
 * compares the `{__html}` object by identity, so a fresh object every render would re-set
 * innerHTML (re-parsing the SVG, wiping anything mounted inside) on every parent render.
 */
export const badgeArtHtml = (
    art: BadgeArtSpec,
    state: BadgeArtState,
    idPrefix: string,
): { __html: string } => {
    const key = `${idPrefix}|${state}|${badgeArtVersion(art)}`
    let html = cache.get(key)
    if (!html) {
        html = { __html: renderBadgeSvg(art, { idPrefix, state, colors: BADGE_ART_CSS_COLORS }) }
        cache.set(key, html)
    }
    return html
}
